import React from 'react';

function HomePageAboutSection() {
  return (
    <section className='grid w-full bg-colour4 '>
      <div className='grid lg:grid-cols-[1fr_2fr] pt-12 xl:grid-cols-[2fr_1.5fr] w-full lg:min-h-[80vh] lg:container lg:mx-auto pb-8'>
        {/* Article */}
        <section className='grid w-full text-center lg:text-left px-4'>
          <article className='grid gap-8 px-2 py-4 pr-6 lg:px-12 lg:py-8 xl:px-16 xl:py-10'>
            {/* Headers */}
            <section className='grid lg:gap-y-2'>
              <div>
                <h4 className='font-argesta text-xl lg:text-2xl italic tracking-widest'>
                  "Surrender yourself to Me and I will unlock the depths of your
                  desires"
                </h4>
              </div>
            </section>
            <section className='grid lg:text-lg gap-y-4 font-argesta'>
              <p>
                I am a Mistress Diva, an Elegant, Exclusive Goddess of Erotic
                Domination, BDSM, Fetishes and all things Kink. Well renowned
                International Dominatrix I conduct sessions and appointments
                in Australia.
              </p>
              <p>
                I am a powerful Dominant, creative Mistress and a passionate
                fetish practitioner of the arts of BDSM, Kinks, Fetishes and
                Desires with a deep passion and fascination of the mind. A
                natural Seductress, I will use My beauty and Femininity over
                you, captivating you and hypnotising you into complete
                submission.
              </p>
              <p>
                As a skilled BDSM practitioner, I am here as your guide, your
                Goddess, your Mistress and your Dominant. Whether you're a
                submissive, slave, seasoned devotee of submission or a curious
                explorer of kink, allow Me to guide you safely and sensually
                into the deepest darkest recesses of your mind and into the
                depths of your most deviant desires.
              </p>
              <p>
                My sessions are personalised and are one of a kind experiences,
                enabling submissive males like yourself to realise their full
                potential while serving Me.
              </p>
              <p>- Mistress Diva</p>
            </section>
          </article>
        </section>

        {/* Images */}
        <section className='hidden lg:grid w-full border-8 border-solid border-colour7'>
          <div className='bg-mainOne bg-cover bg-center bg-no-repeat lg:bg-[center_top_20%] full_shadow_black_invert_big'></div>
        </section>
      </div>
    </section>
  );
}

export default HomePageAboutSection;
